export const sizeToBytes = (size) => {
  if (!size || typeof size !== "string") return 0;

  const [value, unit] = size.toLowerCase().split(" ");

  const num = parseFloat(value);
  if (isNaN(num)) return 0;

  switch (unit) {
    case "bytes":
    case "byte":
      return num;
    case "kb":
      return num * 1024;
    case "mb":
      return num * 1024 * 1024;
    case "gb":
      return num * 1024 * 1024 * 1024;
    case "tb":
      return num * 1024 * 1024 * 1024 * 1024;
    default:
      return 0;
  }
};
